var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.25h14v1.5H4v-1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.055 11.116 13.47 4.53l1.06-1.06 6.586 6.585a2.75 2.75 0 0 1 0 3.89L14.53 20.53l-1.06-1.06 6.585-6.586a1.25 1.25 0 0 0 0-1.768Z",
    fill: "currentColor"
  })));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDExLjI1TDE4IDExLjI1TDE4IDEyLjc1TDQgMTIuNzVMNCAxMS4yNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwLjA1NTUgMTEuMTE2MkwxMy40Njk3IDQuNTMwMzlMMTQuNTMwNCAzLjQ2OTczTDIxLjExNjIgMTAuMDU1NUMyMi4xOTAxIDExLjEyOTUgMjIuMTkwMSAxMi44NzA3IDIxLjExNjIgMTMuOTQ0NkwxNC41MzA0IDIwLjUzMDRMMTMuNDY5NyAxOS40Njk3TDIwLjA1NTUgMTIuODgzOUMyMC41NDM3IDEyLjM5NTggMjAuNTQzNyAxMS42MDQzIDIwLjA1NTUgMTEuMTE2MloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";